import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ReplaySubject, takeUntil } from 'rxjs';
import { ActivatedRoute, Data } from '@angular/router';

import { EndUserLicenseAgreement, EndUserLicenseAgreementService } from './end-user-license-agreement.service';
import { GlobalConstants } from '@v2/configs/global.constants';
import { AuthenticationService } from '../auth/authentication.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-end-user-license-agreement',
  imports: [TranslatePipe, NgScrollbarModule],
  templateUrl: './end-user-license-agreement.component.html',
  styleUrls: ['./end-user-license-agreement.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EndUserLicenseAgreementComponent implements OnInit, OnDestroy {
  endUserLicenseAgreementText = signal('');

  private endUserLicenseAgreementId!: number;

  private readonly endUserLicenseAgreementService = inject(EndUserLicenseAgreementService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authenticationService = inject(AuthenticationService);

  private readonly destroyed$ = new ReplaySubject(1);

  ngOnInit(): void {
    this.activatedRoute.data.pipe(takeUntil(this.destroyed$)).subscribe((response: Data) => {
      const languageCode = localStorage.getItem(GlobalConstants.languageLocalStorageItemKey);
      const endUserLicenseAgreement = response['endUserLicenseAgreement'] as EndUserLicenseAgreement;

      this.endUserLicenseAgreementId = endUserLicenseAgreement.id;

      if (languageCode === 'nl') {
        this.endUserLicenseAgreementText.set(endUserLicenseAgreement.dutchVersion);
      } else {
        this.endUserLicenseAgreementText.set(endUserLicenseAgreement.englishVersion);
      }
    });
  }

  accept(): void {
    this.endUserLicenseAgreementService
      .accept(this.endUserLicenseAgreementId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => (location.href = '/supplier/home'));
  }

  reject(): void {
    this.authenticationService.logout();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
